import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import * as FileSaver from 'file-saver';
@Component({
  selector: 'app-incubator-list',
  templateUrl: './incubator-list.component.html',
  styleUrls: ['./incubator-list.component.css'],
})
export class IncubatorListComponent implements OnInit {
  displayedColumns: string[] = [
    'index',
    'incubatorName',
    'profileRegistered',
    'scoreGenerated',
    'Action',
  ];
  dataSource: MatTableDataSource<any>;
  formValue: FormGroup;
  @ViewChild('input') inputElement: ElementRef<HTMLInputElement>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  private listApi = environment.url + environment.incubaterList;
  private excelDownload = environment.url + 'exportTnimm';
  /**
   * Class constructor.
   * Initializes the component by setting up the form and table data source.
   * @param router The angular router service.
   * @param fb The angular form builder service.
   * @param makeapi The API service provider.
   * @param getdata The Value service provider.
   * @param dialog The Material dialog service provider.
   */
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    public dialog: MatDialog
  ) {
    /**
     * Initialize the MatTableDataSource with empty data.
     */
    this.dataSource = new MatTableDataSource();

    /**
     * Create the form group with the required fields.
     */
    this.formValue = this.fb.group({
      type: ['0'], // Default value set to '0' for "Pending"
    });
  }

  roleValue;
  ProfileUpdated;
  /**
   * OnInit lifecycle hook. Called when the component is initialized.
   * Sets the visible source flag to true in the ValueService.
   * Retrieves the role and profile updated value from session storage.
   * Sets the search value from session storage if exists.
   * Sets the page number and page size from session storage if exists.
   * Sets the initial value of the type form control based on the profile updated value.
   * Calls the eventList method to fetch the list of incubators.
   */
  ngOnInit(): void {
    this.getdata.isVisibleSource.next(true);
    this.roleValue = sessionStorage.getItem('role');
    this.ProfileUpdated = sessionStorage.getItem('IncubatorFilter');
    // Set the search value from session storage if exists
    this.searchValue = sessionStorage.getItem('incubatorSearchValue') || '';

    // Set the page number and page size from session storage if exists
    this.pageNumberSession =
      Number(sessionStorage.getItem('pageNumberSession')) || 1;
    this.pageSizeSession =
      Number(sessionStorage.getItem('pageSizeSession')) || 25;

    // Set the initial value of the type form control based on the profile updated value
    if (this.ProfileUpdated != null) {
      this.formValue.get('type')?.setValue(this.ProfileUpdated);
      this.selectedOption = this.ProfileUpdated;
    }

    // Fetch the list of incubators
    this.eventList();
  }

  // Search code
  searchValue: string;
  /**
   * Applies a search filter based on user input and fetches the filtered list.
   * Triggers the List API call if the search value length is either 0 or 3.
   *
   * @param event - The input event containing the search value.
   */
  applySearch(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchValue = filterValue;
    sessionStorage.setItem('incubatorSearchValue', this.searchValue);
    sessionStorage.removeItem('pageNumberSession');
    sessionStorage.removeItem('pageSizeSession');

    // Reset pagination if the paginator is defined
    if (this.paginator != undefined) {
      this.paginator.pageIndex = 0;
      this.pageNumberSession = 1;
    }

    // Call the API to fetch the filtered list if the search value length is either 0 or 3
    if (this.searchValue.length > 3 || this.searchValue.length == 0) {
      // Create the request object with the current search parameters and pagination
      this.list = {
        listSize: this.pageSizeSession, // The number of items to fetch from the API
        pageNumber: this.pageNumberSession, // The page number to fetch from the API
        incubatorName: this.searchValue, // The search value to search for
        profileUpdated: this.ProfileUpdated ? this.ProfileUpdated : '0', // The selected profile updated status
      };
      this.ListApi();
    }
  }
  list = {};
  disList: any = [];
  pageTotalCount: number;
  pageSizeSession: number = 25;
  pageNumberSession: number = 1;
  noData = true;
  /**
   * Fetches the list of events based on the current search parameters and pagination.
   * Updates the list object with the required parameters and calls the ListApi function
   * to refresh the list of events.
   */
  eventList() {
    // Create the request object with the current search parameters and pagination
    this.list = {
      listSize: this.pageSizeSession, // The number of items to fetch from the API
      pageNumber: this.pageNumberSession, // The page number to fetch from the API
      incubatorName: this.searchValue, // The search value for filtering events
      profileUpdated: this.ProfileUpdated ? this.ProfileUpdated : '0', // The status filter for events
    };

    // Call the ListApi function to fetch the list of events from the API
    this.ListApi();
  }
  /**
   * Fetches the list of incubators from the API based on the current search parameters
   * and pagination.
   * Subscribes to the API response and updates the component's data fields based on the response.
   * @returns An observable containing the response from the API.
   */
  ListApi() {
    this.getdata.amizhthLoader('show');

    /**
     * The API endpoint to call.
     */
    const apiEndpoint = this.listApi;

    /**
     * The data to send in the request body.
     */
    const list = this.list;

    return this.makeapi.method(apiEndpoint, list, 'post').subscribe((data) => {
      this.getdata.amizhthLoader('hide');

      /**
       * If no data is returned, show the "No Data" message.
       */
      if (data.totalIncubators == 0) {
        this.noData = true;
      } else {
        /**
         * If data is returned, update the component's data fields.
         */
        this.noData = false;
        /**
         * The total count of incubators.
         */
        this.pageTotalCount = data.totalIncubators;
        /**
         * The list of incubators to display.
         */
        this.disList = data.incubators;
        /**
         * The MatTableDataSource with the list of incubators.
         */
        this.dataSource = new MatTableDataSource(data.incubators);
      }
    });
  }
  adminIncub;
  /**
   * Saves the incubator name and ID to the session storage and navigates to the admin dashboard.
   * @param id The ID of the incubator.
   * @param name The name of the incubator.
   */
  incubaName(id, name) {
    // Save the incubator ID to the session storage.
    sessionStorage.setItem('incubator', id);
    // Save the incubator name to the session storage.
    sessionStorage.setItem('adminIncubName', name);
    // Set a flag in session storage to indicate an active incubation.
    sessionStorage.setItem('adminIncubVal', '1');

    // Retrieve the flag from session storage.
    this.adminIncub = sessionStorage.getItem('adminIncubVal');

    // If the flag is set to '1', navigate to the admin dashboard.
    if (this.adminIncub == '1') {
      this.router.navigateByUrl('/admin/dashboard');
    }
  }
  /**
   * Saves the incubator ID to session storage and navigates to the profile page.
   * @param id The incubator ID.
   */
  profileGet(id) {
    // Save the incubator ID to the session storage.
    sessionStorage.setItem('incubatorId', id);
    // Navigate to the profile page.
    this.router.navigateByUrl('/profile');
  }
  /**
   * Lifecycle hook that is called after the component's view has been fully initialized.
   * Used to set the paginator's page size and index after the component has been initialized.
   */
  ngAfterViewInit() {
    // Set a timeout to ensure that the paginator is only updated after the component has been fully initialized.
    setTimeout(() => {
      if (this.paginator) {
        // Set the page size to the value stored in session storage.
        this.paginator.pageSize = this.pageSizeSession;
        // Set the page index to the value stored in session storage, subtracting 1 because the paginator uses a zero-based index.
        this.paginator.pageIndex = Math.max(this.pageNumberSession - 1, 0);
      }
    }, 0);
  }
  selectedOption = '0';

  /**
   * Handles the pagination event.
   * Resets the input field, updates the session storage with page number and size,
   * and calls the ListApi function to fetch the updated data.
   * @param event The pagination event containing the page index and page size.
   */
  getServerData(event) {
    // Reset the input field if it exists
    if (this.inputElement && this.inputElement.nativeElement) {
      this.inputElement.nativeElement.value = '';
    }

    // Update the page number and page size (convert zero-based index to one-based)
    this.pageNumberSession = event.pageIndex + 1;
    this.pageSizeSession = event.pageSize;

    // Store the updated page number and size in session storage
    sessionStorage.setItem(
      'pageNumberSession',
      this.pageNumberSession.toString()
    );
    sessionStorage.setItem('pageSizeSession', this.pageSizeSession.toString());

    // Create the request parameters for the API call
    this.list = {
      listSize: this.pageSizeSession,
      pageNumber: this.pageNumberSession,
      profileUpdated: parseInt(this.selectedOption),
    };

    // Call the API to fetch the updated data
    this.ListApi();
  }
  /**
   * Handles the selection change event for the status option.
   * Updates the search value, resets input fields, and updates the session storage.
   * Resets pagination and triggers the list API to fetch data based on the selected status.
   * @param option The selected status option.
   */
  onSelect(option) {
    // Clear the search value
    this.searchValue = '';

    // Reset the input element's value if it exists
    if (this.inputElement && this.inputElement.nativeElement) {
      this.inputElement.nativeElement.value = '';
    }

    // Remove the search value and pagination parameters from session storage
    sessionStorage.removeItem('incubatorSearchValue');
    sessionStorage.removeItem('pageNumberSession');
    sessionStorage.removeItem('pageSizeSession');

    // Update the selected option and store it in session storage
    this.selectedOption = option;
    this.ProfileUpdated = this.selectedOption;
    sessionStorage.setItem('IncubatorFilter', this.selectedOption);

    // Reset pagination if the paginator is defined
    if (this.paginator != undefined) {
      this.paginator.pageIndex = 0;
      this.pageNumberSession = 1;
    }

    // Update the list object with the new status and pagination details
    this.list = {
      listSize: this.pageSizeSession,
      pageNumber: this.pageNumberSession,
      profileUpdated: this.selectedOption,
    };

    // Call the API to fetch the updated list based on the selected status
    this.ListApi();
  }
  /**
   * @description
   * This method returns the appropriate background color based on the registration status of an incubator.
   * @param val - The registration status of an incubator.
   * @returns The background color associated with the provided registration status.
   */
  pickBgColor(val: number): string {
    return this.getdata.registerStatus(val);
  }
  /**
   * Downloads the incubatee list as an Excel file.
   * Shows a loading indicator during the request and hides it once the file is downloaded.
   * The file is saved with a name based on the current date and time.
   */
  downloadExcel() {
    // Show loading indicator
    this.getdata.amizhthLoader('show');

    // Make API call to download the Excel file
    this.makeapi
      .method(
        this.excelDownload, // Excel download URL with user ID
        '',
        'download'
      )
      .subscribe((data) => {
        // Hide loading indicator
        this.getdata.amizhthLoader('hide');

        // Generate the current date and time for the filename
        const date = new Date();
        let currentDate = `${date.getFullYear()}-${
          date.getMonth() + 1
        }-${date.getDate()}-${date.getSeconds()}`;

        // Define the filename with the current date and time
        let filename = 'StartupTN_Incubators_' + currentDate + '.xlsx';

        // Save the downloaded file using FileSaver
        FileSaver.saveAs(data, filename);
      });
  }
}
